export default function StatCard({ label, value, accent = 'primary', icon, secondary = false }) {
  const modifier = accent !== 'primary' ? ` stat-card--${accent}` : '';
  const size = secondary ? ' stat-card--secondary' : '';
  return (
    <div className={`stat-card${modifier}${size}`}>
      <div className="stat-card__icon">{icon}</div>
      <div>
        <div className="stat-card__label">{label}</div>
        <div className="stat-card__value">{value ?? '—'}</div>
      </div>
    </div>
  );
}

export function InboxIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 12h-4l-1 2h-4l-1-2H5V5h14v10z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AlertIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2L1 21h22L12 2zm0 16a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm1-4h-2v-5h2v5z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ClockIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zm.5-13H11v6l5 3 .8-1.3-4.3-2.6V7z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M9 16.2l-3.5-3.5L4 14.2 9 19.2l11-11L18.6 6.8 9 16.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M17 3h-1V1h-2v2H10V1H8v2H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H7V9h10v10zm0-12H7V5h10v2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StopwatchIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42-1.42-1.42-1.5 1.5A9 9 0 1012 22a9 9 0 007.03-14.61zM12 20a7 7 0 110-14 7 7 0 010 14z"
        fill="currentColor"
      />
    </svg>
  );
}
